import { posthog } from 'posthog-js';

interface ErrorContext {
  component?: string;
  action?: string;
  stack?: string;
}

export class ErrorHandler {
  static logError(error: unknown, context: ErrorContext = {}) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    const stackTrace = error instanceof Error ? error.stack : undefined;

    // Log to PostHog
    if (typeof window !== 'undefined') {
      posthog.capture('error', {
        message: errorMessage,
        stack: stackTrace,
        ...context,
        url: window.location.href,
      });
      posthog.captureException(error);
    }

    // Log to console
    console.error('Application Error:', {
      message: errorMessage,
      stack: stackTrace,
      ...context,
    });
  }
}
